module.exports = __webpack_public_path__ + "img/02.d2f0df4e.jpg";